import { useParams } from "react-router-dom";
import { createContext } from "./createContext";

export const getChains = () =>
  Object.values({
    classic: {
      name: "classic",
      chainID: "columbus-5",
      lcd: "https://terra-classic-fcd.publicnode.com",
      //"api": "https://columbus-api.terra.dev",
      //"mantle": "https://columbus-mantle.terra.dev",
      walletconnectID: 2
    }
  });

export const [useChains, ChainsProvider] =
  createContext<ChainOption[]>("Chains");

const useNetworkFromRouteMatch = () => {
  const { network } = useParams();
  return network;
};

export const useCurrentChain = () => {
  const chains: ChainOption[] = useChains();
  const network = useNetworkFromRouteMatch();

  const chain =
    chains.find(chain => chain.name === network || chain.chainID === network) ??
    chains.find(chain => chain.name === "classic"); // return mainnet for default chain

  if (!chain) {
    throw new Error("Chain is not defined");
  }

  return chain;
};

export const useFCDURL = () => {
  const { lcd } = useCurrentChain();
  return lcd.replace("lcd", "fcd");
};

export const useIsClassic = () => {
  const { chainID } = useCurrentChain();
  return chainID.startsWith("columbus");
};
